import { X, FileText, RefreshCw } from "lucide-react";
import { Button } from "../components/ui/button";
import { Input } from "../components/ui/input";

export function PatientBillModal({ show, onClose, form, setForm, onGenerate, loading }) {
  if (!show) return null;
  return (
    <div className="fixed inset-0 z-50 bg-black/40 backdrop-blur-sm flex items-center justify-center p-4" onClick={onClose} data-testid="patient-bill-modal">
      <div className="bg-white rounded-2xl shadow-2xl w-full max-w-lg overflow-hidden" onClick={e => e.stopPropagation()}>
        <div className="px-6 py-4 border-b border-slate-100 flex items-center justify-between bg-violet-50">
          <div>
            <h3 className="text-sm font-bold text-slate-800">Patient Bill - Date Wise Medicine Report</h3>
            <p className="text-xs text-slate-500 mt-0.5">Enter patient details to generate the report</p>
          </div>
          <Button variant="ghost" size="icon" onClick={onClose} data-testid="close-patient-bill"><X className="w-4 h-4" /></Button>
        </div>
        <div className="p-6 space-y-4 max-h-[70vh] overflow-y-auto">
          <div className="grid grid-cols-2 gap-4">
            <div>
              <label className="text-xs font-semibold text-slate-600 mb-1 block">MRN Number <span className="text-red-500">*</span></label>
              <Input placeholder="e.g. 09456" value={form.mrn} data-testid="pb-mrn"
                onChange={e => setForm(f => ({ ...f, mrn: e.target.value }))} />
            </div>
            <div>
              <label className="text-xs font-semibold text-slate-600 mb-1 block">Visit No. / IP Number</label>
              <Input placeholder="e.g. IP/25002334" value={form.visit_no} data-testid="pb-visit"
                onChange={e => setForm(f => ({ ...f, visit_no: e.target.value }))} />
            </div>
          </div>
          <div>
            <label className="text-xs font-semibold text-slate-600 mb-1 block">Patient Name</label>
            <Input placeholder="e.g. Mrs. SHENBAGA VALLI M/71Y" value={form.patient_name} data-testid="pb-name"
              onChange={e => setForm(f => ({ ...f, patient_name: e.target.value }))} />
          </div>
          <div className="grid grid-cols-2 gap-4">
            <div>
              <label className="text-xs font-semibold text-slate-600 mb-1 block">Ward / Room / Bed</label>
              <Input placeholder="e.g. 3RD FLOOR/304/C" value={form.ward_room_bed} data-testid="pb-ward"
                onChange={e => setForm(f => ({ ...f, ward_room_bed: e.target.value }))} />
            </div>
            <div>
              <label className="text-xs font-semibold text-slate-600 mb-1 block">Admitted Time</label>
              <Input placeholder="e.g. 09-12-25 03:11PM" value={form.admitted_time} data-testid="pb-admitted"
                onChange={e => setForm(f => ({ ...f, admitted_time: e.target.value }))} />
            </div>
          </div>
          <div className="grid grid-cols-2 gap-4">
            <div>
              <label className="text-xs font-semibold text-slate-600 mb-1 block">Consultant</label>
              <Input placeholder="e.g. Dr. SURIYA PRAKASH" value={form.consultant} data-testid="pb-consultant"
                onChange={e => setForm(f => ({ ...f, consultant: e.target.value }))} />
            </div>
            <div>
              <label className="text-xs font-semibold text-slate-600 mb-1 block">Discharged</label>
              <Input placeholder="e.g. 28-01-26 08:56AM" value={form.discharged} data-testid="pb-discharged"
                onChange={e => setForm(f => ({ ...f, discharged: e.target.value }))} />
            </div>
          </div>
        </div>
        <div className="px-6 py-4 border-t border-slate-100 flex justify-end gap-3">
          <Button variant="outline" size="sm" onClick={onClose}>Cancel</Button>
          <Button size="sm" onClick={onGenerate} disabled={loading || !form.mrn} data-testid="pb-generate"
            className="bg-violet-600 hover:bg-violet-700 text-white">
            {loading ? <RefreshCw className="w-3.5 h-3.5 mr-1 animate-spin" /> : <FileText className="w-3.5 h-3.5 mr-1" />}
            Generate Report
          </Button>
        </div>
      </div>
    </div>
  );
}
